import {Box} from "@mui/material";
import {PropsWithChildren} from "react";
import {BounceLogo} from "@bounce/shared/ui/assets";
import {Container} from "~/new-design/components";
import {Footer} from "~/new-design/layout/Footer";
import {colors, spacing} from "~/new-design/theme";

export const AgentPageFrame = ({children}: PropsWithChildren) => (
  <Box sx={{minHeight: "100svh", display: "flex", flexDirection: "column", backgroundColor: colors.tertiary[200]}}>
    <Container center sx={{padding: `${spacing[8]} ${spacing[4]} ${spacing[2]}`}}>
      <BounceLogo color={colors.primary[800]} width="110px" height="23px" />
    </Container>
    <Box sx={{flex: 1}}>{children}</Box>
    <Footer />
  </Box>
);
